import styled from 'styled-components';

export const Container = styled.div`
  padding: 20px;
  min-width: 500px;
  max-width: 600px;
  color: #333;
  background-color: #fff;
  
  * {
    color: inherit;
  }
`;

export const WrapperInput = styled.div`
  margin-bottom: 20px;
`;

export const WrapperButtons = styled.div`
  display: flex;
  justify-content: flex-end;
  margin-top: 30px;
  padding-top: 20px;
  border-top: 1px solid #ddd;
`;

